import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router";
import { useEffect, useState } from "react";
import $ from "jquery";
import "datatables.net";
import "datatables.net-bs4";
import { ConfigService } from "./Service";
import toast from "react-hot-toast";
import Config from "../../core/config/Config";

const ManageConfig = () => {
  const service = new ConfigService();
  const navigate = useNavigate();
  const location = useLocation();

  const getData = () => {
    try {
      $("#table").DataTable().destroy();
    } catch (e) {
      console.log(e);
    }
    let token = localStorage.getItem("token");
    $("#table").DataTable({
      lengthMenu: [10, 20, 50, 100, 500, 1000],
      pageLength: 100,
      processing: true,
      serverSide: true,
      columnDefs: [
        // Show input for value
        {
          render: function (data, type, row) {
            return `<input type="text" class="form-control" value="${data[1]}" />`;
          },
          createdCell: (td, cellData, rowData, row, col) => {
            // On change update using servier.update
            $(td).change(async (e) => {
              let token = localStorage.getItem("token");
              console.log(cellData, rowData, e.target.value);
              let data = {
                attribute: rowData[0],
                value: e.target.value,
              };
              let response = await service.update(cellData[0], data);
              if (response) {
                toast.success("Config updated Successfully");
              }
            });
          },
          targets: 1,
        },
      ],
      ajax: {
        url: `${Config.apiCoreBaseUrl}/admin/config/list`,
        type: "POST",
        contentType: "application/json",
        headers: {
          Authorization: token,
        },
        data: function (d) {
          return JSON.stringify({
            ...d,
          });
        },
      },
    });
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <div className={"d-flex justify-content-between container-fluid w-100"}>
        <h3 className="card-title p-2">Config Management</h3>
      </div>
      <div className="card m-3">
        <div className="card-body">
          <div className="table-responsive w-100">
            <table id="table" className="table datatable w-100">
              <thead>
                <tr>
                  <th>Attribute</th>
                  <th>Value</th>
                  <th>Added Date</th>
                </tr>
              </thead>
              <tbody></tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageConfig;
